import { FC } from 'react';
import { IconButton, Stack } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import SettingsIco from '@mui/icons-material/Settings';
import { dictionaryState } from '../../../../../../../shared/components/dictionary/states/dictionary.state';

export const NameDictCell: FC<TNameDictCell> = (props) => {
  const { value, row, id, onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    dictionaryState.pub.selectRow(row);
    onClick();
  };

  return (
    <SStack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
      <SValue>{value}</SValue>
      <IconButton
        className='button'
        disabled={row.invalid || String(id).includes('new')}
        title={t('settings.post_sectors_one')}
        onClick={handleClick}
        sx={{ p: '3.5px' }}
        size='small'
      >
        <SettingsIco />
      </IconButton>
    </SStack>
  );
};

const SStack = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const SValue = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

type TNameDictCell = GridRenderCellParams & {
  onClick: () => void;
};
